export default {"src":"/_next/static/media/zgraph.c727a5f7.svg","height":680,"width":984};